import 'arrive';
import $ from 'jquery';
import Swiper from 'swiper';

document.arrive('.block-linked-card-carousel', {existing: true}, function(){
    const blockName = '.block-linked-card-carousel';
    const sliderCP = '__slider';
    const slider = this.querySelector(`${blockName}${sliderCP}`);
    const pagination = this.querySelector(`${blockName}${sliderCP}__bullets`);
    const breakpoints = {
        0: {
            slidesPerView: 1,
        },
        992: {
            slidesPerView: 2
        }
    };
    var swiper;

    const sliderInit = () => {
        swiper = new Swiper(slider, {
            slidesPerView: 2,
            breakpoints,
            spaceBetween: 40,
            pagination: {
                el: pagination,
                type: 'bullets',
                clickable: true
            }
        });
    }

    sliderInit();
});